export default "__VITE_ASSET__CNOoS_XA__"